import { Drawer } from '@navi/web-ui/lib/primitives';
import { useDispatch } from 'react-redux';
import { getAllCorporateNumbersforAgent } from '../../actions/agentFormActions';
import { useState } from 'react';
import { Button } from '@navi/web-ui/lib/primitives';
import styles from '../../AgentForm.module.scss';
import BackIcon from '@cp/src/assets/images/icons/BackIcon';
import CorporateNumbers from './CorporateNumbers';
import { Agent } from '../../interfaces/types';

interface CorporateNumbersDrawerProps {
  isEditDisabled: boolean | undefined;
  agentData: Agent;
}
const CorporateNumbersDrawer = ({ isEditDisabled, agentData }: CorporateNumbersDrawerProps) => {
  const [isCorporateNosDrawerOpen, setIsCorporateNosDrawerOpen] = useState(false);
  const [isCorporateNosLoading, setIsCorporateNosLoading] = useState(false);
  const dispatch = useDispatch();

  const handleCorporateNumbers = () => {
    setIsCorporateNosLoading(true);
    dispatch(getAllCorporateNumbersforAgent(agentData.referenceId || '', setIsCorporateNosLoading));
    setIsCorporateNosDrawerOpen(true);
  };
  return (
    <>
      {isEditDisabled && (
        <Button
          onClick={handleCorporateNumbers}
          variant="text"
          className={styles.viewAllCorporateNumbers}
        >
          View all corporate numbers
        </Button>
      )}

      <Drawer
        open={isCorporateNosDrawerOpen}
        headerText="All corporate numbers"
        showHeaderDivider={true}
        onClose={() => setIsCorporateNosDrawerOpen(false)}
        className={styles.corporateNosDrawer}
        footerContainerClasses="!px-4 !py-3"
        customIcon={<BackIcon color="var(--grayscale-3)" />}
        headerContainerClasses="gap-2"
        contentClasses="overflow-auto"
      >
        <CorporateNumbers isCorporateNosLoading={isCorporateNosLoading} />
      </Drawer>
    </>
  );
};

export default CorporateNumbersDrawer;
